import React from 'react';
import { useMediaQuery, Theme } from '@mui/material';

import { Button, Typography } from '@occc/ui-design-system';
import { MyAccountIcon } from '@occc/ui-design-system/icons';

export interface MyAccountButtonProps {
  handleMenuOpen: React.MouseEventHandler<HTMLElement>;
  isMenuOpen: boolean;
}

const BUTTON_BACKGROUND = 'rgba(255, 255, 255, 0.2)';

export const MyAccountButton: React.FC<MyAccountButtonProps> = ({ handleMenuOpen }) => {
  const isMobileView = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  return isMobileView ? (
    <Button
      sx={{
        background: BUTTON_BACKGROUND,
      }}
      onClick={handleMenuOpen}
    >
      <MyAccountIcon />
    </Button>
  ) : (
    <Button
      sx={{
        color: 'inherit',
        ml: 'auto',
        minWidth: 150,
        textTransform: 'capitalize',
        background: BUTTON_BACKGROUND,
      }}
      endIcon={<MyAccountIcon sx={{ ml: 1 }} />}
      onClick={handleMenuOpen}
      data-testid='myAccount'
    >
      <Typography variant='subtitle2' component='span'>
        my account
      </Typography>
    </Button>
  );
};
